import EventEmitter from "eventemitter3";
import { scrollTo } from "../utils";

let selection = [];
let edit_mode = false;
let interaction = true;
let hideShareIcon = true;

export default class Bookmark extends EventEmitter {
  constructor(parent, versoId, scope = null) {
    super();
    this.parent = parent;

    const bookmark = document.createElement("div");
    bookmark.classList.add("bookmark");
    parent.appendChild(bookmark);

    const icon = document.createElement("button");
    icon.setAttribute("tabindex", 1);
    icon.innerHTML = "bookmark";
    icon.classList.add("icon", "bookmarkSelector");
    icon.setAttribute("id", versoId);
    bookmark.appendChild(icon);

    // make icon clickable
    // console.warn(icon.parentNode.parentNode);
    if (Bookmark.selection.includes(versoId)) icon.classList.add("active");
    Bookmark.activateIcon(icon.parentNode.parentNode, scope);
  }

  static activateIcon(icon, scope = null) {
    icon.addEventListener("click", (e) => {
      if (interaction) {
        // console.warn("click on image", e.target);

        let TARGET = e.target;
        if (e.target.tagName === "IMG") {
          TARGET =
            e.target.parentNode.parentNode.parentNode.querySelector(".icon");
        }

        console.warn(TARGET);
        if (TARGET.classList.contains("bookmarkSelector")) {
          TARGET.classList.toggle("active");

          const id = TARGET.getAttribute("id");

          //   remove an item from page in 'edit mode'
          if (edit_mode) {
            const bookmarkElement = TARGET.parentNode;
            const wrapper = bookmarkElement.parentNode;
            const container = wrapper.parentNode;
            container.removeChild(wrapper);
            selection.splice(selection.indexOf(id), 1);
            if (
              selection.length == 0 &&
              document.body.classList.contains("modern")
            ) {
              // Bookmark.emit("empty");
              console.warn("SELECTION IS EMPTY NOW");
              scope.bookmarks();
              // window.scrollTo({ top: 0, behavior: "smooth" });
              scrollTo(0, scope.iOS());
            }
            if (scope.tracker) scope.tracker.track("BOOKMARK_REMOVE", id);
          } else {
            //   add remove to list in 'normal mode'
            if (TARGET.classList.contains("active")) {
              if (selection.indexOf(id) == -1) {
                selection.push(id);
              }
              if (scope.tracker) scope.tracker.track("BOOKMARK_ADD", id);
              scope.toolTips.showToolTipForAWhile(1, 2000);
            } else {
              if (selection.indexOf(id) != -1) {
                selection.splice(selection.indexOf(id), 1);
                console.warn("SELECTION ", selection);
                if (
                  selection.length == 0 &&
                  document.body.classList.contains("modern")
                ) {
                  // Bookmark.emit("empty");
                  console.warn("SELECTION IS EMPTY NOW");
                  scope.bookmarks();
                  // window.scrollTo({ top: 0, behavior: "smooth" });
                  scrollTo(0, scope.iOS());
                }
                if (scope.tracker) scope.tracker.track("BOOKMARK_REMOVE", id);
              }
            }
          }
        }
      }
    });

    const id = icon.getAttribute("id");
    icon.classList.remove("active");
    if (selection.indexOf(id) != -1) icon.classList.add("active");
  }

  static get selection() {
    return selection;
  }
  static set selection(val) {
    selection = val;
  }
  static get EDIT() {
    return edit_mode;
  }
  static set EDIT(value) {
    edit_mode = value;
  }
  static get INTERACTION() {
    return interaction;
  }
  static set INTERACTION(value) {
    interaction = value;
  }

  static set HIDE_SHARING(value) {
    hideShareIcon = value;
  }

  static get HIDE_SHARING() {
    return hideShareIcon;
  }
}
